// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"styles_contentWrapper__3MfBM","registerButton":"styles_registerButton__Al3_z"};